import { IRaffleDefaultRewardDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { useEffect, useState } from "react";
import { RaffleDefaultNumberRewardInfo } from "./rewardInfo";

interface IProps {
  rewards: IRaffleDefaultRewardDTO[];
}

export function RaffleDefaultNumberRewards({ rewards }: IProps) {
  const [reward, setReward] = useState<IRaffleDefaultRewardDTO | undefined>(
    undefined
  );

  useEffect(() => {
    setReward(rewards[0]);
  }, [rewards]);

  return (
    <>
      {rewards.length > 0 ? (
        <>
          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
              <div className="navbar-collapse" id="navBarRaffleDefaultNumber">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-center w-100">
                  {rewards.map((item, i) => (
                    <li
                      key={`${item?.order}-${item?.name}-${i}`}
                      className="nav-item d-flex justify-content-center align-items-center"
                      style={{ flex: 1 }}
                    >
                      <button
                        className={`nav-link ${i === 0 ? `active` : ``} w-100`}
                        onClick={() => setReward(item)}
                      >
                        <span className="fw-bold">{item?.name}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </nav>
          {reward ? (
            <RaffleDefaultNumberRewardInfo reward={reward} />
          ) : (
            <div className="text-center">
              <span>Selecione um prêmio.</span>
            </div>
          )}
        </>
      ) : (
        <span>Nenhum prêmio encontrado.</span>
      )}
    </>
  );
}
